export const environment = {
	production: true,
	appVersion: "v726demo1",
	USERDATA_KEY: "authf649fc9a5f55",
	isMockEnabled: true,
	apiUrl: "api",
	backend_server: "https://backend.simplefactura.cl/api",
	simpleFono_server: "https://twilio.chilesystems.com",
	signalR_server: "https://alerthub.simplefactura.cl/alertahub",
	taxPercentage: 0.19,
	country_code_port: 41,
	checkSession: true,
	msal_client_key: "",
	msal_authority: "",
	msal_return_url: "",
	msal_postlogout_redirect_uri: "",
	msal_graph_endpoint: "",
	title: "SimpleFactura",
	idleTimeout: 900,
	logoutTimeout: 30,
	oauthRedirectUrl: "https://app.simplefactura.cl/auth/",
	googleClientId: "111819077648-c79hdsd5g922jae49pt6emntkkeo7njh.apps.googleusercontent.com",
	githubClientId: "Ov23litQDukU9PLNgOw4",
	linkedinClientId: "772xa9erpp5j5r",
	microsoftClientId: "a4e1afe5-930f-4490-9300-428514db0095",
	microsoftTenant: "common",
	withholdBheValues: [0.13, 0.1375, 0.145, 0.1525, 0.16, 0.17],
	googleMapsApiKey: "AIzaSyDdivpOIC07bxRiAaoQniZr75-AHsMj7sU"
};
 
